/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerjaarnumber_Twee3Inputs */

const nl_enums_leerjaarnumber_twee3 = /** @type {(inputs: Enums_Leerjaarnumber_Twee3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2`)
};

/**

* @param {Enums_Leerjaarnumber_Twee3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerjaarnumber_twee3 = /** @type {((inputs?: Enums_Leerjaarnumber_Twee3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerjaarnumber_Twee3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerjaarnumber_twee3(inputs)
});
export { enums_leerjaarnumber_twee3 as "enums.LeerjaarNumber.Twee" }